import I18n from 'components/I18n'
import Money from 'components/Money'
import supportLink from 'constants/support'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

const Wrapper = styled.div`
  margin-top: 0.5rem;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: ${color('body')};
`

const LearnMoreLink = styled.a`
  color: ${color('blue600')};
  text-decoration: none;

  :hover {
    color: ${color('blue500')};
  }
`

type BalanceProps = {
  mainAmount: number
  mainCurrency: string
  secondaryAmount?: number
  secondaryCurrency?: string
}
const Balance = ({
  mainAmount,
  mainCurrency,
  secondaryAmount,
  secondaryCurrency
}: BalanceProps) => (
  <Wrapper data-e2e='withdrawableBalance'>
    <I18n data={messages.withdraw_balance} />: <Money amount={mainAmount} currency={mainCurrency} />
    &nbsp;
    {secondaryAmount && secondaryCurrency && mainCurrency !== secondaryCurrency && (
      <Money amount={secondaryAmount} currency={secondaryCurrency} />
    )}{' '}
    <LearnMoreLink
      href={`${supportLink}/en-us/articles/4417087718292-How-do-I-deposit-GBP-or-EUR-via-Instant-Transfers-with-Open-Banking-`}
      rel='noopener noreferrer'
      target='_blank'
    >
      <I18n data={messages.button_learn_more} />
    </LearnMoreLink>
  </Wrapper>
)

export default Balance
